export default __webpack_public_path__ + "static/Greenhouse_Window-6769bd7e0309dc915b9760964677a973.png";